import { render, staticRenderFns } from "./ValidationDetails.vue?vue&type=template&id=9121043e"
import script from "./ValidationDetails.vue?vue&type=script&lang=js"
export * from "./ValidationDetails.vue?vue&type=script&lang=js"
import style0 from "./ValidationDetails.vue?vue&type=style&index=0&id=9121043e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports